import { gql } from "@apollo/client";

const GET_SHIPPING_DATA = gql`
  query shippingMethodsData($countries: [String!]!) {
    shippingMethodsData(countries: $countries) {
      country
      methods {
        id
        label
        cost
        tax
        total
        currency
        freeShippingMinAmount
      }
    }
  }
`;

export default GET_SHIPPING_DATA;
